import styled, { css } from 'styled-components';
import { ESort, ISortingIndicatorStyledProps, ITableHeadStyledProps } from './table.types';

export const SortingIndicatorStyled = styled.div<ISortingIndicatorStyledProps>`
  display: flex;
  align-items: center;

  svg {
    display: block;
    transform: rotate(${({ $order }) => $order === ESort.DESC ? '180deg' : 0});
  }
`;

export const TableHeadStyled = styled.thead<ITableHeadStyledProps>`
  tr {
    outline: 1px solid ${({ theme }) => theme.colors.gray[10]};
    border-radius: 12px 12px 0 0;

    ${({ $isSticky, $stickyOffset }) => $isSticky && css`
      position: sticky;
      top: ${$stickyOffset};
      box-shadow: 0 -6px 6px 6px ${({ theme }) => theme.colors.gray[3]};
      z-index: 1;
    `};
  }

  th {
    text-align: left;
    padding: 8px 16px;
    user-select: none;
    cursor: pointer;
    font-size: 12px;
    font-weight: 500;
    line-height: 16px;
    color: ${({ theme }) => theme.colors.gray[40]};
    background-color: ${({ theme }) => theme.colors.gray[0]};
    box-sizing: border-box;

    .col-head {
      display: flex;
      align-items: center;
      gap: 4px;
    }

    .col-caption {
      word-break: keep-all;
      white-space: nowrap;
    }

    &:first-child {
      border-radius: 12px 0 0 0;
    }

    &:last-child {
      border-radius: 0 12px 0 0;
    }
  }
`;

export const TableBodyStyled = styled.tbody`
  tr {
    &.white {
      background-color: ${({ theme }) => theme.colors.gray[0]};
    }

    &.gray {
      background-color: ${({ theme }) => theme.colors.gray[3]};
    }

    &.green {
      background-color: ${({ theme }) => theme.colors.green[5]};
    }

    &.red {
      background-color: ${({ theme }) => theme.colors.red[5]};
    }

    &.blue {
      background-color: ${({ theme }) => theme.colors.blue[5]};
    }
  }

  td {
    padding: 18px 16px;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    vertical-align: top;
    border-top: 1px solid ${({ theme }) => theme.colors.gray[10]};
    color: ${({ theme }) => theme.colors.gray[70]};
  }
`;

export const TableStyled = styled.table`
  table-layout: fixed;
  width: 100%;
  border-radius: 12px;
  border-spacing: 0;
  border: 1px solid ${({ theme }) => theme.colors.gray[10]};
  box-shadow: 0px 2px 4px 0px ${({ theme }) => theme.colors.gray[80]}14, 0px 0px 6px 0px ${({ theme }) => theme.colors.gray[80]}0A;
`;

export const TableWrapperStyled = styled.div`
  position: relative;
  min-height: 60px;
`;
